import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AuthInterceptor } from '@core/helpers/auth-interceptor';

import { AppComponent } from './app.component';
import { SharedModule } from '@shared/shared.module';
import { DecimalPipe } from '@angular/common';
import { AuthGuard } from '@core/guards/auth.guard';
import { NgxMaskDirective, provideEnvironmentNgxMask } from 'ngx-mask';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const LukerPreset = definePreset(Aura, {
    semantic: {
        // Brand yellow (#F6D24B) scale, replacing PrimeNG's default "primary"
        // (emerald/green) so every unstyled component (buttons, links, focus
        // rings, etc.) uses the brand color instead of green on hover/focus.
        primary: {
            50: '#FEF9EC',
            100: '#FDF4D8',
            200: '#FBE9B1',
            300: '#F9DD8B',
            400: '#F7D369',
            500: '#F6D24B',
            600: '#F3BE20',
            700: '#D5A30B',
            800: '#AA8109',
            900: '#836407',
            950: '#574305',
        },
        colorScheme: {
            light: {
                // Keep the same brand yellow on hover/active instead of
                // PrimeNG's default darker shade, so buttons/links don't
                // change color on hover.
                primary: {
                    hoverColor: '#F6D24B',
                    activeColor: '#F6D24B',
                },
                highlight: {
                    background: '#FCF1C7',
                    focusBackground: '#F9E186',
                    color: '#675820',
                    focusColor: '#675820',
                },
                formField: {
                    focusBorderColor: '#F6D24B',
                    disabledBackground: '#F9F9F9',
                    disabledColor: '#A8ABAE',
                },
                list: {
                    option: {
                        focusBackground: '#FEFBED',
                    },
                },
            },
        },
    },
    components: {
        datepicker: {
            date: {
                hoverBackground: '#FEFBED',
                selectedBackground: '#F6D24B',
                selectedColor: '#212529',
                rangeSelectedBackground: '#FCF1C7',
                rangeSelectedColor: '#675820',
            },
            selectMonth: {
                hoverBackground: '#FEFBED',
            },
            selectYear: {
                hoverBackground: '#FEFBED',
            },
            colorScheme: {
                light: {
                    today: {
                        background: '#F9E186',
                        color: '#675820',
                    },
                },
            },
        },
        checkbox: {
            root: {
                width: '1.375rem',
                height: '1.375rem',
                checkedBackground: '#F6D24B',
                checkedHoverBackground: '#F6D24B',
                checkedBorderColor: '#F6D24B',
                checkedHoverBorderColor: '#F6D24B',
                checkedFocusBorderColor: '#F6D24B',
            },
            icon: {
                size: '0.9375rem',
            },
        },
    },
});

@NgModule({
    declarations: [AppComponent,],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule], providers: [
            DecimalPipe,
            HttpClient,
            AuthGuard,
            { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
            provideEnvironmentNgxMask({
                thousandSeparator: ",",
                decimalMarker: ".",
                allowNegativeNumbers: false,
            }),
            provideHttpClient(withInterceptorsFromDi()),
            providePrimeNG({
                theme: {
                    preset: LukerPreset,
                    options: {
                        darkModeSelector: false,
                    },
                },
            }),
        ]
})
export class AppModule { }
